module.exports = __webpack_public_path__ + "img/tg_02 (14).da774671.jpg";